import { Box, Grid, Radio, Typography } from "@mui/material";
import React from "react";
import InformationCard from "src/components/InformationCard";
import OnsiteMeetingCard from "src/components/OnsiteMeetingCard";
import treffas from "src/theme/treffas";

const { colors, typography, radius } = treffas;

const ChooseVideoLink = ({
  conferenceType,
  setConferenceType,
  selectedOffer,
  customStyle = {},
  sx,
}) => {
  const headingFont = customStyle?.headingFont
    ? `var(--font-${customStyle.headingFont})`
    : typography.fontFamily.headingMedium;
  const bodyFont = customStyle?.bodyFont
    ? `var(--font-${customStyle.bodyFont})`
    : typography.fontFamily.body;
  const textColor = customStyle?.textColor ?? colors.text.strong;
  const secondaryTextColor =
    customStyle?.secondaryTextColor ?? colors.text.secondary;
  const borderColor = customStyle?.borderColor ?? colors.border.strong;
  const accentColor = customStyle?.accentColor ?? colors.brand.primary;

  const integratedVideoConference =
    selectedOffer?.enabled_integrations?.length > 0
      ? selectedOffer?.enabled_integrations.filter(
        (integration) =>
          integration.integration.name?.toLowerCase() === "zoom" ||
          integration.integration.name?.toLowerCase() === "google meet"
      )
      : [];

  const meetingType =
    selectedOffer?.custom_options?.meeting_type ?? "virtual-meeting";
  const meetingLocation =
    selectedOffer?.custom_options?.meeting_location || "No location provided.";

  if (meetingType === "onsite-meeting") {
    return (
      <OnsiteMeetingCard
        customStyle={customStyle}
        meetingLocation={meetingLocation}
      />
    );
  }

  return (
    <Box
      sx={{
        mt: "30px",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
          justifyContent: { xs: "flex-start", sm: "space-between" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: "10px",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontFamily: headingFont,
              fontSize: "18px",
              lineHeight: "23px",
              color: textColor,
            }}
          >
            Video Conference
          </Typography>

          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "18px",
              color: secondaryTextColor,
              fontFamily: bodyFont,
              mt: "4px",
            }}
          >
            Select the video conference platform you want to use for this
            booking.
          </Typography>
        </Box>
      </Box>

      {integratedVideoConference.length === 0 && (
        <Box sx={{ mt: "20px" }}>
          <InformationCard
            customStyle={customStyle}
            label={
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "normal",
                  fontFamily: bodyFont,
                }}
              >
                Booking will be created without video conference url included.
              </Typography>
            }
          />
        </Box>
      )}

      {integratedVideoConference.length > 0 && (
        <Grid container spacing={2} sx={{ mt: "8px" }}>
          {integratedVideoConference.map((integration, index) => {
            const isSelected =
              conferenceType?.toLowerCase() ===
              integration.integration.name?.toLowerCase();
            const conferenceName = integration.integration.name?.toLowerCase();

            return (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  onClick={() => setConferenceType(conferenceName)}
                  sx={{
                    p: "10px 20px",
                    borderRadius: radius.lg,
                    backgroundColor: isSelected
                      ? colors.brand.primarySoft
                      : colors.background.default,
                    border: `1px solid ${isSelected ? accentColor : borderColor}`,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "10px",
                    alignSelf: "stretch",
                    cursor: "pointer",
                  }}
                >
                  <Radio
                    checked={isSelected}
                    name="choose_video_link"
                    onChange={() => setConferenceType(conferenceName)}
                    sx={{
                      color: borderColor,
                      "&.Mui-checked": {
                        color: accentColor,
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "normal",
                      textTransform: "capitalize",
                      fontFamily: bodyFont,
                      color: textColor,
                    }}
                  >
                    {integration.integration.name}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default ChooseVideoLink;
